import { memo } from 'react';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';

import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';

const Header = () => {
  const { isWeb } = useBatchData();
  return isWeb ? <DesktopHeader /> : <MobileHeader />;
};

export default memo(Header);
